import { SimulationSteps, StepsTravel } from "./travel-hire-menu-types";

export class TravelHireMenuHelper {
  static getStepFromNavigationRoute(path: string, product: string): StepsTravel {
    if (path.indexOf(`/contratacion/nueva/travel/${product}/tomador`) !== -1)
      return StepsTravel.DatosTomador;
    else if (path.indexOf(`/contratacion/nueva/travel/${product}/asegurados`) !== -1)
      return StepsTravel.DatosAsegurados;
    else if (path.indexOf(`/contratacion/nueva/travel/${product}/proteccion-datos`) !== -1)
      return StepsTravel.ProteccionDatos;
    else if (path.indexOf(`/contratacion/nueva/travel/${product}/medios-pago`) !== -1)
      return StepsTravel.MetodosPago;
    else if (path.indexOf(`/contratacion/nueva/travel/${product}/resultado`) !== -1)
      return StepsTravel.DetallePrevioContratacion;
    else return StepsTravel.DatosTomador;
  }

  static getStepNavigationPath(step: StepsTravel, insuredsLength: number, product: string): string {
    let currentInsured = insuredsLength - 1;
    currentInsured = currentInsured < 0 ? 0 : currentInsured;
    switch (step) {
      case StepsTravel.DatosTomador:
        return `/contratacion/nueva/travel/${product}/tomador`;
      case StepsTravel.DatosAsegurados:
        return insuredsLength === 0
          ? `/contratacion/nueva/travel/${product}/asegurados/`
          : `/contratacion/nueva/travel/${product}/asegurados/${currentInsured}`;
      case StepsTravel.ProteccionDatos:
        return `/contratacion/nueva/travel/${product}/proteccion-datos`;
      case StepsTravel.MetodosPago:
        return `/contratacion/nueva/travel/${product}/medios-pago`;
      case StepsTravel.DetallePrevioContratacion:
        return `/contratacion/nueva/travel/${product}/resultado`;
      default:
        return "";
    }
  }

  static getPreviousStep(currentStep: StepsTravel): StepsTravel {
    try {
      return currentStep - 1;
    } catch {
      return StepsTravel.DatosTomador;
    }
  }

  static getFirstStep(): StepsTravel {
    return StepsTravel.DatosTomador;
  }

  static getSimulationStepNavigationPath(
    step: SimulationSteps,
    product: string,
  ): string {
    switch (step) {
      case SimulationSteps.DatosRiesgo:
        return `/simulacion/nueva/travel/${product}/mediador`;
      case SimulationSteps.Resumen:
        return `/simulacion/nueva/travel/${product}/resultado`;
      default:
        return "";
    }
  }

  static getSimulationStepFromNavigationRoute(path: string, product: string): SimulationSteps {
    if (path.indexOf(`/simulacion/nueva/travel/${product}/asegurados`) !== -1)
      return SimulationSteps.DatosRiesgo;
    else if (path.indexOf(`/simulacion/nueva/travel/${product}/resultado`) !== -1)
      return SimulationSteps.Resumen;
    else return SimulationSteps.DatosRiesgo;
  }

  static getPreviousStepNavigationPath(currentStep: number, product: string): string {
    return this.getStepNavigationPath(this.getPreviousStep(currentStep), 1, product);
  }

  static getNextStep(currentStep: StepsTravel): StepsTravel {
    try {
      return currentStep + 1;
    } catch {
      return StepsTravel.DetallePrevioContratacion;
    }
  }

  static getNextStepNavigationPath(currentStep: StepsTravel, product: string): string {
    return this.getStepNavigationPath(this.getNextStep(currentStep), 1, product);
  }
}
